module.exports = __webpack_public_path__ + "img/europass.3e4ee533.png";